/*
 * Copyright Innov'ATM all rights reserved.
 * This software is the property of Innov'ATM and may not be used in any manner except under a
 * license agreement signed with Innov'ATM.
 */

import { MenuItem, SelectChangeEvent } from '@mui/material';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Resource, ResourceType } from '../../../../../../backend';
import { Select } from '../../../../../form/Select/Select';
import { selectSx } from './ResourcesSelect.style';

export const ResourceSelect = memo(function ResourceSelect({
    selectedValue,
    isResourceLinked,
    resourceType,
    isArrival,
    allResources,
    handleLinkedChange,
    handleUnlinkedChange,
    disabled,
    addLabelFlowSuffix = true,
}: {
    selectedValue?: string;
    isResourceLinked: boolean;
    resourceType: ResourceType;
    isArrival: boolean;
    allResources: Resource[];
    handleLinkedChange: (event: SelectChangeEvent, resourceType: ResourceType) => void;
    handleUnlinkedChange: (event: SelectChangeEvent, resourceType: ResourceType, isArrival: boolean) => void;
    disabled: boolean;
    addLabelFlowSuffix?: boolean;
}) {
    const activeRelevantResources = allResources?.filter(r => r.type === resourceType && r.active);

    return (
        <Select
            value={selectedValue || ''}
            onChange={(event: SelectChangeEvent) =>
                isResourceLinked
                    ? handleLinkedChange(event, resourceType)
                    : handleUnlinkedChange(event, resourceType, isArrival)
            }
            label={
                <FormattedMessage
                    id={`turnaround.popin.field`}
                    values={{ field: addLabelFlowSuffix ? resourceType + (isArrival ? '_ARR' : '_DEP') : resourceType }}
                />
            }
            fullWidth
            FormControlProps={{
                sx: selectSx,
            }}
            disabled={disabled}
        >
            {!activeRelevantResources?.find(r => r.name === selectedValue) && (
                <MenuItem value={selectedValue} disabled={true}>
                    <em>{selectedValue}</em>
                </MenuItem>
            )}
            <MenuItem value={''}>
                <em>-</em>
            </MenuItem>
            {activeRelevantResources?.map(({ name }) => (
                <MenuItem key={name} value={name}>
                    <FormattedMessage id={`turnaround.popin.field`} values={{ field: name }} />
                </MenuItem>
            ))}
        </Select>
    );
});
